import { render, staticRenderFns } from "./UdefSorting.vue?vue&type=template&id=6081cfbe&scoped=true&"
import script from "./UdefSorting.vue?vue&type=script&lang=js&"
export * from "./UdefSorting.vue?vue&type=script&lang=js&"
import style0 from "./UdefSorting.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UdefSorting.vue?vue&type=style&index=1&id=6081cfbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6081cfbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VList,VListItem,VListItemTitle,VMenu,VRadio,VRadioGroup})
